import http from 'axios'
import config from 'src/config'
import { show } from 'features/Toasts/Toasts.actions.js'
import { nodes } from './Flow/Flow.data'
import { filter } from 'lodash'
import showConfirmModal from 'features/Modal/ConfirmModal/ConfirmModal.action'
import { getNumbers } from 'features/Numbers/Numbers.actions'
import { push } from 'react-router-redux'

export const listTriggers = () => ({
  type: 'FLOWS/LIST_TRIGGERS',
  payload: http({
    method: 'GET',
    url: `${config.api.main}/api/v1/flows/triggers`,
    params: {
      type: 'contact_subscribed',
    },
  }),
})

export const listTemplates = () => ({
  type: 'FLOWS/LIST_TEMPLATES',
  payload: http({
    method: 'GET',
    url: `${config.api.main}/api/v1/flow-templates`,
  }),
})

export const createFlow = data => ({
  type: 'FLOWS/CREATE_FLOW',
  payload: http({
    method: 'POST',
    url: `${config.api.main}/api/v1/flows`,
    data,
  }),
})

export const getPricing = () => ({
  type: 'FLOWS/GET_PRICING',
  payload: http({
    method: 'GET',
    url: `${config.api.main}/api/v1/pricing`,
  }),
})

export const getFlowLogs = ({ flowId, contactId, page, cacheKey }) => ({
  type: 'FLOWS/GET_FLOW_LOGS',
  payload: http({
    method: 'GET',
    url: `${config.api.main}/api/v1/flow-logs`,
    params: {
      page,
      limit: 20,
      filter: {
        flowId,
        contactId,
      },
    },
  }),
  meta: {
    cacheKey,
  },
})

export const getFlowLog = ({ flowLogId }) => ({
  type: 'FLOWS/GET_FLOW_LOG',
  payload: http({
    method: 'GET',
    url: `${config.api.main}/api/v1/flow-logs/${flowLogId}`,
  }),
  meta: {
    flowLogId,
  },
})

export const deleteFlow = flowId => ({
  type: 'FLOWS/DELETE_FLOW',
  payload: http({
    method: 'DELETE',
    url: `${config.api.main}/api/v1/flows/${flowId}`,
  }),
  meta: {
    flowId,
  },
})

export const confirmDeleteFlow = flowId => dispatch =>
  dispatch(showConfirmModal({ message: 'Are you sure?<br/>This cannot be undone.' }))
    .then(() => dispatch(deleteFlow(flowId)))
    .then(() => dispatch(push('/dashboard/flows')))

const validateFlow = (getState, dispatch, flowData, ifValidCallback) => {
  // Show a toast for standard validation
  const nodeForms = flowData.nodes.map(node => ({
    form: getState().form[node.id] || {},
    node,
  }))
  const invalidNodeForm = nodeForms.find(
    item => item.form.syncErrors && Object.keys(item.form.syncErrors).length > 0
  )
  if (invalidNodeForm) {
    return dispatch(
      show({
        title: `Cannot save: Please fix the '${nodes[invalidNodeForm.node.type].label}' node.`,
        type: 'error',
      })
    )
  }
  return ifValidCallback()
}

const addBanToFlow = (flow, numbersById) => {
  const incomingCallNode = flow.nodes.find(node => node.type === 'incoming_call')
  if (incomingCallNode) {
    const number = numbersById[incomingCallNode.extras.numberSid]
    if (number) {
      return {
        ...flow,
        ban: number.ban,
      }
    }
  }
  return flow
}

export const publishFlow = flowData => (dispatch, getState) =>
  validateFlow(getState, dispatch, flowData, () => {
    const numbersById = getState().numbers.numbersById

    const sendThePublishRequest = () =>
      dispatch({
        type: 'FLOWS/PUBLISH_FLOW',
        payload: http({
          method: 'PUT',
          url: `${config.api.main}/api/v1/flows/${flowData.id}/publish`,
          data: addBanToFlow(flowData, numbersById),
        }),
      })

    // Special publish validation
    const incomingCallNodes = filter(flowData.nodes, ['type', 'incoming_call'])
    const incomingSmsNodes = filter(flowData.nodes, ['type', 'incoming_sms'])
    const incomingCallNumbers = incomingCallNodes.map(node => numbersById[node.extras.numberSid])
    const incomingSmsNumbers = incomingSmsNodes.map(node => numbersById[node.extras.numberSid])

    const incomingCallNumbersConnectedToOtherFlows = filter(
      incomingCallNumbers,
      number => number && number.twilioCallFlowId && number.twilioCallFlowId !== flowData.id
    )
    const incomingSmsNumbersConnectedToOtherFlows = filter(
      incomingSmsNumbers,
      number => number && number.twilioFaxFlowId && number.twilioFaxFlowId !== flowData.id
    )

    if (
      incomingCallNumbersConnectedToOtherFlows.length >= 1 ||
      incomingSmsNumbersConnectedToOtherFlows.length >= 1
    ) {
      const message = `
    <div>Are you sure?</div></br>
    <small>
      ${incomingSmsNumbersConnectedToOtherFlows.map(
        number => `<div>${number.number} is connected to another call flow.</div>`
      )}
      ${incomingCallNumbersConnectedToOtherFlows.map(
        number => `<div>${number.number} is connected to another SMS flow.</div>`
      )}
    </small>
    <small>This will be overwritten.</small>
    `
      return dispatch(showConfirmModal({ message }))
        .then(sendThePublishRequest)
        .then(() => dispatch(getNumbers())) // We get the numbers so they flowIds are updated (this make above validation work if it is triggered again)
    }

    return sendThePublishRequest().then(() => dispatch(getNumbers()))
  })

export const saveFlow = flowData => (dispatch, getState) =>
  validateFlow(getState, dispatch, flowData, () =>
    dispatch({
      type: 'FLOWS/SAVE_FLOW',
      payload: http({
        method: 'PUT',
        url: `${config.api.main}/api/v1/flows/${flowData.id}`,
        data: addBanToFlow(flowData, getState().numbers.numbersById),
      }),
    })
  )

export const getFlow = flowId => ({
  type: 'FLOWS/GET_FLOW',
  payload: http({
    method: 'GET',
    url: `${config.api.main}/api/v1/flows/${flowId}`,
  }),
})

export const getFlows = () => ({
  type: 'FLOWS/GET_FLOWS',
  payload: http({
    method: 'GET',
    url: `${config.api.main}/api/v1/flows`,
  }),
})



// WEBPACK FOOTER //
// ./src/features/Flows/Flows.actions.js